export const cookie = (key: string, value?: string) => {
    if (typeof document === "undefined") return;
    if (typeof key === "string" && typeof value === "string") {
      document.cookie = `${key}=${value};path=/`;
      return value;
    }
    if (document?.cookie?.indexOf(`${key}=`) === -1) return;
    const cookies = ";" + document.cookie?.replaceAll(" ", "");
    return cookies.split(`;${key}=`)[1]?.split(";")[0];
  };
  
export const isWebView = () => {
    //return true if page open in app
    if (cookie("webview") === "android_app" || cookie("webview") === "ios_app")
      return true;
  
    return false;
  };

export const callFlutterEventHandler = (data: any) => {
  (window as any).flutter_inappwebview.callHandler("WebViewConnect", data);
};

export function openHomepage({ link }: any) {
  if (isWebView()) {
    const data = {
      action: "my_account"
    };
    callFlutterEventHandler(JSON.stringify(data));
    return;
  }
  window.location.href = link;
  return;
}